module.exports = __webpack_public_path__ + "img/Empty_Profile.7ef985cb.png";